import { inject } from '@angular/core';
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';
import { BYPASS_LOADER } from '@app/services/util-services/root-services/http-client.service';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

export const HttpLoaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const loaderService: LoaderUtilService = inject(LoaderUtilService);
  const b2bDeviceUtilService: B2bDeviceUtilService =
    inject(B2bDeviceUtilService);

  if (req.context.get(BYPASS_LOADER) === true) {
    return next(req);
  } else {
    if (!b2bDeviceUtilService?.isDesktop()) {
      // Default show on mobile web and app
      loaderService.show('Loading', {
        backdrop: true,
      });
    }

    return next(req).pipe(
      finalize(async () => {
        loaderService.hide();
      }),
    );
  }
};
